module.exports = __webpack_public_path__ + "static/mobileHash-84ef4b8085805e44f24097b5287c00c9.png";